export default __webpack_public_path__ + "static/media/m1.84764abf.jpg";